import React from 'react';
import './RestaurantGeneralInfo.less';
import {BlockTitle} from "elements/block-title/BlockTitle";
import {BlockDescription} from "elements/block-description/BlockDescription";
import {RestaurantName} from "elements/restaurant-name/RestaurantName";

export const RestaurantGeneralInfo = ({title, description}) => {
	return <div className="restaurant-general-info">
		<div className="restaurant-general-info__title">
			<RestaurantName text={title}/>
		</div>
		{
			description && (<div className="restaurant-general-info__description">
				<BlockDescription text={description}/>
			</div>)
		}
	</div>
}
